// extracted by mini-css-extract-plugin
export default {"linktest":"Nav_linktest__LLk3F","navbar":"Nav_navbar__lN5AK","logo":"Nav_logo__NuKcq","contact":"Nav_contact__-zLUo"};